<template>
  <v-card>
    <alert-error :error="error"></alert-error>

    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.ADD') }} {{ $t('PERSONAL_INTERESTS.ITEM') }}</span
      >
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <item-form v-model="tag" :languages="languages" />

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>
            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
            >
              {{ $t('BUTTON.CREATE') }}
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TagCreatePage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ItemForm: () => import('@/modules/tags/components/TagForm.vue')
  },

  props: {
    languages: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    tag: {},
    error: null,
    valid: true
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        let translations = [];

        this.languages.forEach(language => {
          if (this.tag[language.locale]) {
            translations.push({
              language_id: language.id,
              name: this.tag[language.locale]
            });
          }
        });

        this.tagSend = {
          translations: translations
        };
        this.$store
          .dispatch('tag/store', this.tagSend)
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    }
  }
};
</script>
